import React from "react";


function BundlesHeader() {

    return (
        <>
            <div className="pd-header">

                <div className="header-bottom">
                    <h2 className="pd-title has-bg-image">Multi-workshop Bundles</h2>
                </div>
            </div>
        </>
    );
}

export default BundlesHeader;
